export class StoreCapableItemTypesResponse {
    limit: number;
    offset: number;
    resultCount: number;
    results?: (StoreCapableItemTypesResultEntity)[] | null;
    sortBy: string;
    sortOrder: string;
}

export class StoreCapableItemTypesResultEntity {
    itemTypeId: number;
    itemTypename: string;
    checked: boolean;
}
